'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _MImageBody2 = require('./MImageBody');

var _MImageBody3 = _interopRequireDefault(_MImageBody2);

var _index = require('../../../index');

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MStickerBody = function (_MImageBody) {
    (0, _inherits3.default)(MStickerBody, _MImageBody);

    function MStickerBody() {
        (0, _classCallCheck3.default)(this, MStickerBody);
        return (0, _possibleConstructorReturn3.default)(this, (MStickerBody.__proto__ || (0, _getPrototypeOf2.default)(MStickerBody)).apply(this, arguments));
    }

    (0, _createClass3.default)(MStickerBody, [{
        key: 'onClick',

        // Mostly empty to prevent default behaviour of MImageBody
        value: function onClick(ev) {
            ev.preventDefault();
            if (!this.state.showImage) {
                this.showImage();
            }
        }

        // MStickerBody doesn't need a wrapping `<a href=...>`, but it does need extra padding
        // which is added by mx_MStickerBody_wrapper

    }, {
        key: 'wrapImage',
        value: function wrapImage(contentUrl, children) {
            var onClick = null;
            if (!this.state.showImage) {
                onClick = this.onClick;
            }
            return _react2.default.createElement(
                'div',
                { className: 'mx_MStickerBody_wrapper', onClick: onClick },
                ' ',
                children,
                ' '
            );
        }

        // Don't show "Download this_file.png ..."

    }, {
        key: 'getFileBody',
        value: function getFileBody() {
            var MessageOverlay = _index2.default.getComponent('messages.MessageOverlay');
            var messageOverlay = this.props.messageOverlayPosition === 'content' ? _react2.default.createElement(MessageOverlay, {
                mxEvent: this.props.mxEvent,
                tileShape: this.props.tileShape,
                continuation: this.props.continuation,
                permalinkCreator: this.props.permalinkCreator
            }) : undefined;

            return messageOverlay;
        }
    }]);
    return MStickerBody;
}(_MImageBody3.default); /*
                         Copyright 2018 New Vector Ltd
                         Licensed under the Apache License, Version 2.0 (the "License");
                         you may not use this file except in compliance with the License.
                         You may obtain a copy of the License at
                             http://www.apache.org/licenses/LICENSE-2.0
                         Unless required by applicable law or agreed to in writing, software
                         distributed under the License is distributed on an "AS IS" BASIS,
                         WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
                         See the License for the specific language governing permissions and
                         limitations under the License.
                         */

exports.default = MStickerBody;
module.exports = exports['default'];
//# sourceMappingURL=MStickerBody.js.map